import Moderation from '../components/ReserveModeration/Moderation'

let routes = {
    path: '/reserveModeration',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [        
        {
            path: '/reserveModeration/moderation',
            name: 'Moderação de Reservas',
            component: Moderation
        }
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/reserveModeration.js